module.exports = __webpack_public_path__ + "img/oil.35186100.svg";